<template>
    <div
        :class="[{ disabled: isLoading }, 'position-relative']"
    >
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <ui-input
            @input="fetch"
            v-model="q"
            :label="label"
            :placeholder="placeholder"
            class="input"
        >
            <ui-icon
                slot="icon"
                icon="search"
            />
        </ui-input>

        <slot
            :data="data"
        />
    </div>
</template>

<script>
    import axios from 'axios';

    import UiIcon from './icon.vue';
    import UiInput from './input.vue';
    import UiSpinner from './spinner.vue';

    export default {
        name: 'UiListSearch',
        components: {
            UiIcon,
            UiInput,
            UiSpinner,
        },
        props: {
            fetchOnLoad: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
                default: null,
            },
            placeholder: {
                type: String,
                default: 'Zoek',
            },
            url: {
                type: [String, Object],
                default: null,
            },
            platform: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                data: [],
                debounce: null,
                isLoading: false,
                q: null,
            };
        },
        created() {
            if (this.fetchOnLoad) {
                this.fetch();
            }
        },
        methods: {
            fetch(q = '') {
                if (!this.url || q.length < 3) {
                    return;
                }

                clearTimeout(this.debounce);

                this.isLoading = true;

                this.debounce = setTimeout(async () => {
                    const { data } = await axios.get(this.url, { params: { q, platform: this.platform } });

                    this.data = (Array.isArray(data)) ? data : data[Object.keys(data)];
                    this.isLoading = false;
                }, 250);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .icon {
        position: absolute;
    }

    .input {
        position: relative;
    }

    .spinner-holder {
        z-index: 2;
    }
</style>
